import { dispatchAddToCartEvent, dispatchRemoveFromCart } from './events.js';
import { reloadicons } from './svg.js';
import { getCookie, getPage, loadHeaderPurchaseListCarrousel, scrollCart } from './utilities.js';

jQuery(function () {
	
	/* atualiza o numero no icone do carrinho */
	updateTextQtdIcon();
	updateShippingBar();


	/* remove do carrinho */
	$(document).on("click", ".miniCart .btn-cart-remove", function () {
		$(this).html('<i class="iconload"></i>');
		var mlistid = $(this).attr("data-purchaselist");
		reloadicons();
		delCart(mlistid);
	});
	/* aumenta a quantidade no carrinho */
	$(document).on("click", ".miniCart .qtd_add", function () {
		var mc_lid = $(this).attr("data-purchaselist");
		var element_qtd = $(".miniCart ul li[data-purchaselist=" + mc_lid + "] .qtd_number");
		var mc_amount = element_qtd.val();
		qtdCart(mc_lid, mc_amount, element_qtd, 'add');
	});
	/* diminui a quantidade no carrinho */
	$(document).on("click", ".miniCart .qtd_rem", function () {
		var mc_lid = $(this).attr("data-purchaselist");
		var element_qtd = $(".miniCart ul li[data-purchaselist=" + mc_lid + "] .qtd_number");
		var mc_amount = element_qtd.val();
		qtdCart(mc_lid, mc_amount, element_qtd, 'rem');
	});

	/* aumenta a quantidade no carrinho */
	$(document).on("change", ".miniCart .mc-qtd input", function (e) {
		//$(".miniCart.aberto .mc-buttons").removeClass("d-none");
		var mc_lid = $(this).attr("data-purchaselist");
		var element_qtd = $(this);
		var mc_amount = element_qtd.val();
		qtdCart(mc_lid, mc_amount, element_qtd, 'change');
	});
	$(document).on("focus", ".miniCart ul .qtd_number", function () {
		//$(".miniCart.aberto .mc-buttons").addClass("d-none");
		//$('.miniCart.aberto').animate({scrollTop: $(this).offset().top},'slow');
		//$(".miniCart.aberto").scrollTop(altura);
	});
	$(document).on("blur", ".miniCart ul .qtd_number", function () {
		//$(".miniCart.aberto .mc-buttons").removeClass("d-none");
	});

});

/* atualiza o numero no icone do carrinho */
export function updateTextQtdIcon() {
	var totalItens = $(".miniCart input[name=totalItens]").val();
	totalItens = totalItens == "" ? 0 : totalItens;
	$(".desktop-header .items-cart").html(totalItens);
}

/* atualiza o numero no icone do carrinho mobile */
export function updateTextQtdIconMobile() {
	var totalItens = $(".miniCart input[name=totalItens]").val();
	totalItens = totalItens == "" ? 0 : totalItens;
	$("#mobile-headerLine .items-cart").html(totalItens);
	$("#mobile-navbar .qtd-cart").html(totalItens);
}

const getFreeShippingMix = () => {
	let freeMin = document.querySelector(".mc-produtos .container-free-shipping div.text-shipping")?.getAttribute("data-minfree");
	if (freeMin) {
		return parseFloat(freeMin);
	}

	freeMin = document.querySelector("form#form-purchase-list [data-minfree]")?.getAttribute("data-minfree");
	if (freeMin) {
		return parseFloat(freeMin);
	}

	const zipcode = getCookie("zipcode")?.replace(/\D/g,'');
	if ((zipcode >= "72800000" && zipcode <= "74894999") || (zipcode >= "74805000" && zipcode <= "74999999")) {
		return 159;
	}

	return 599.00;
}

export function updateShippingBar(){
	
	const VALUE_TO_FREE_SHIPPING = getFreeShippingMix();
	if (VALUE_TO_FREE_SHIPPING === 0) {
		$(".container-free-shipping").addClass("displaynone");
		return;
	}
	$(".container-free-shipping").removeClass("displaynone");

	var totalValue = 0
	if(getPage() === "purchase-list") {
		totalValue = $(".totalproduct span.total").html()
	} else {
		totalValue = $(".mc-total .mc-price-subtotal .mc-price").html();
	}

	var hasFreeShipping = false
	var text = $(".text-shipping p");

	const totalValueWithoutDots = totalValue.replace('.', "");
	const totalValueWithoutComma = totalValueWithoutDots.replace(',', ".");
	const totalValueFloat = parseFloat(totalValueWithoutComma)
	
	const rest = VALUE_TO_FREE_SHIPPING - totalValueFloat;

	const restForFreeShipping = rest.toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL'
	})

	var percent = Math.floor((totalValueFloat * 100) / VALUE_TO_FREE_SHIPPING);

	if(percent >= 100){
		percent = 100;
		hasFreeShipping = true;
	}

	const percentString = percent+"%"
	
	// $(".container-shipping .shipping-bar").css("width", percentString)
	$(".container-shipping .shipping-bar").each(function() {
    $(this).css("width", percentString);
	});

	if(percent > 0) {
		$(".container-shipping .shipping-bar .dot").css("visibility", "visible");
	} else {
		$(".container-shipping .shipping-bar .dot").css("visibility", "hidden");
	}

	const message = hasFreeShipping
		? "<strong>Frete grátis</strong>"
		: `Faltam <strong>${restForFreeShipping}</strong> para o <strong>Frete grátis</strong>`;

	text.each(function() {
    $(this).html(message);
	});
	
}

export function addCart(pid, sku1, sku2, amount = 1) {
	var aux = "&amount=" + amount;
	if (sku1 != "") {
		aux = aux + "&sku_1=" + sku1;
	}
	if (sku2 > 0) {
		aux = aux + "&sku_2=" + sku2;
	}

	$.ajax({
		type: "POST",
		url: "/carrinho-de-compra/",
		data: "product_id=" + pid + "&addAjax=true&nItens=true" + aux,
		dataType: "json",
		success: function (data) {
			$.ajax({
				type: "POST",
				url: '/carrinho-de-compra/',
				data: 'headerpurchaselistAjax=true',
				dataType: "json",
				success: function (subjson) {
					dispatchAddToCartEvent({ pid, sku1, sku2, amount: parseInt(amount)});
					if (subjson.error != undefined) {
						alert(subjson.error);
					} else {
						$(".miniCart").html(subjson.data);
						let lazyloadImages = document.querySelectorAll(".lazy");
						lazyloadImages.forEach(function (img) {
							img.src = img.dataset.src;
							img.classList.remove('lazy');
						});
						$(document).ready(async function () {
							const { openNav } = await import('./utilities.js');
							openNav();
							const { reloadicons } = await import('./svg.js');
							reloadicons();
							scrollCart()
						});

						$("#miniCart .mc-footer .mc-price-cnpj").html(subjson.totalProductCNPJFormat);
						// $("#miniCart .mc-footer .mc-price-discount").html(subjson.promoDiscountFormat);
						if(subjson.promoDiscount2Format != "0,00"){
							$("#miniCart .mc-footer .mc-price-discount2").html("-"+subjson.promoDiscount2Format);
							$("#miniCart .mc-footer #promoDiscount2").removeClass("displaynone");
						}

						//openNav();
						$(".thumbid" + pid + " .product-thumb-sku ul li").removeClass("actived");
						$(".thumbid" + pid + " .product-thumb-sku ul li").attr("disabled", false);
						updateTextQtdIcon(); // Atualiza o texto do icone do carrinho
						updateShippingBar(); // Atualiza a barra de frete
						updateTextQtdIconMobile(); // Atualiza o texto do icone do carrinho mobile
						loadHeaderPurchaseListCarrousel();
					}
				}
			}).done(function () {
				$(".thumbid" + pid + " .product-thumb-sku ul li").removeClass("disabled");
			});
		}
	});
}

export function delCart(lid) {
	$.ajax({
		type: "GET",
		url: "/carrinho-de-compra/",
		data: "purchase_list_id=" + lid + "&remove=item",
		dataType: "json",
		success: function (data) {
			dispatchRemoveFromCart({ list_id: lid });
			$(".miniCart ul li[data-purchaselist=" + lid + "]").fadeOut("slow", function () {
				$(".miniCart ul li[data-purchaselist=" + lid + "]").remove();
			});

			if (data.totalItens > 0) {
				$(".miniCart .mc-price").html(data.totalProductFormat);
				$(".miniCart .mc-price-subtotal .mc-price").html(data.totalProductFormat);
				$(".miniCart .mc-price-total .mc-price").html(data.totalProductVistaFormat);
				$(".miniCart .mc-price-cnpj").html(data.totalProductCNPJFormat);
				// $(".miniCart .mc-price-discount").html(data.promoDiscountFormat);
				if(data.promoDiscount2Format != undefined){
					$(".miniCart .mc-price-discount2").html("-"+data.promoDiscount2Format);
					$(".miniCart #promoDiscount2").removeClass("displaynone");
				}else{
					$(".miniCart .mc-price-discount2").html("0,00");
					$(".miniCart #promoDiscount2").addClass("displaynone");
				}
			} else {
				$(".miniCart .mc-price").html("0,00");
				$(".miniCart .mc-price-cnpj").html("0,00");
				$(".miniCart .mc-price-discount").html("0,00");
				$(".miniCart .mc-price-discount2").html("0,00");
				$(".miniCart #promoDiscount2").addClass("displaynone")
			}

			$(".miniCart input[name=totalItens]").val(data.totalItens);
			updateTextQtdIcon(); // Atualiza o texto do icone do carrinho
			updateShippingBar(); // Atualiza a barra de frete
			updateTextQtdIconMobile(); // Atualiza o texto do icone do carrinho mobile
			//updateCarrierText(".miniCart .mc-frete"); // Atualizar Informação sobre Frete
		}
	});
}

export function qtdCart(lid, amount, element, act) {
	const alertSupply = element.closest('.mc-info').find(`.alertsupply${lid}`)
	if (act == 'rem' && amount > 1) {
		amount--;
		alertSupply.addClass("displaynone")
	} else if (act == 'add') {
		amount++;
		alertSupply.addClass("displaynone")
	} else if (act == 'change') {
		if (amount <= 0 || isNaN(amount) || amount == "" || amount == undefined) {
			amount = 1;
		}
		const supply = element.data('supply')
		const period = element.data('period')

		if (period == 0 && amount > supply) {
			amount = supply;
			element.closest('.mc-info').find(`.alertsupply${lid} span`).html(supply + " itens");
			alertSupply.removeClass("displaynone")
		}else {
			alertSupply.addClass("displaynone")
		}
	}

	$.ajax({
		type: "GET",
		url: "/carrinho-de-compra/",
		data: "purchase_list_id=" + lid + "&amount=" + amount,
		dataType: "json",
		success: function (data) {
			$.each(data.itens, function (i, item) {
				if (item.list_id == lid) {
					if (item.amount < amount) {
						if (item.amount == 1) {
							$(".alertsupply" + lid + " span").html(item.amount + " item");
						} else {
							$(".alertsupply" + lid + " span").html(item.amount + " itens");
						}
						$(".alertsupply" + lid).removeClass("displaynone");
					} else {
						if (!$(".alertsupply" + lid).hasClass("displaynone")) {
							$(".alertsupply" + lid).addClass("displaynone");
						}
						element.val(amount);
					}
				}
			});

			$(".miniCart .mc-price").html(data.totalProductFormat);
			$(".miniCart .mc-price-total .mc-price").html(data.totalProductVistaFormat);
			$(".miniCart .mc-price-cnpj").html(data.totalProductCNPJFormat);
			$(".miniCart input[name=totalItens]").val(data.totalItens);
			// $(".miniCart .mc-price-discount").html(data.promoDiscountFormat);
			if(data.promoDiscount2Format != undefined){
				$(".miniCart .mc-price-discount2").html("-"+data.promoDiscount2Format);
				$(".miniCart #promoDiscount2").removeClass("displaynone");
			}else{
				$(".miniCart .mc-price-discount2").html("0,00");
				$(".miniCart #promoDiscount2").addClass("displaynone");
			}
			updateTextQtdIcon(); // Atualiza o texto do icone do carrinho
			updateShippingBar(); // Atualiza a barra de frete
			updateTextQtdIconMobile(); // Atualiza o texto do icone do carrinho mobile
			//updateCarrierText(".miniCart .mc-frete"); // Atualizar Informação sobre Frete
		},
	});
}

// Atualizar Informação sobre Frete
export function updateCarrierText(element) {
	$.ajax({
		type: "POST",
		url: "/carrinho-de-compra/",
		data: "purchaseListCarrierAjax=true",
		dataType: "json",
		success: function (json) {
			$(element).html(json.data);
		}
	});
}

export function validaCEP(cep) {
	return /^\d{8}$/.test(cep.replace(/[^\d]+/g, ""));
}